export const REPOSITORIO_HABERES_VARIABLES_MODULE_ID = 'repositorio_haberes_variables'

export function isRepositorioHaberesVariablesModuleId(moduleId) {
  return moduleId === REPOSITORIO_HABERES_VARIABLES_MODULE_ID
}

export { defaultConfiguracionEquipoAccess as defaultRepositorioHaberesVariablesAccess } from './configuracionEquipoModule'

/** Empresa: sin fila → deshabilitado. */
export function defaultRepositorioHaberesVariablesCompanyAccess(existingPerm) {
  if (existingPerm?.hasAccess === true) return true
  if (existingPerm?.hasAccess === false) return false
  return false
}

/**
 * Admin usuario: sin fila explícita → OFF (no mostrar staff default como grant).
 * Runtime (app) sigue usando staff + empresa.
 */
export function defaultRepositorioHaberesVariablesUserAdminAccess(existingPerm) {
  if (existingPerm?.hasAccess === true) return true
  if (existingPerm?.hasAccess === false) return false
  return false
}
